module.exports = __webpack_public_path__ + "static/main_03-ff66881bb457d066336b22c3da816eac.png";